<template>
  <div class="pageView">
    <div v-for="(item, index) in mpPrivacyData" :key="index">
      <mpTitle
        v-if="item.type === 'title'"
        :title="item.title"
        :subTitle="item.subTitle"
      ></mpTitle>
      <mpDiver v-if="item.type === 'divers'"></mpDiver>
      <mpContext v-if="item.type === 'context'" :context="item.context">
      </mpContext>
      <mpTContext
        v-if="item.type === 'titleAndcontext'"
        :title="item.title"
        :context="item.context"
        :subTitle="item.subTitle"
      ></mpTContext>
      <mpFooter
        v-if="item.type === 'footer'"
        :title="item.title"
        :subTitle="item.subTitle"
      ></mpFooter>
    </div>
  </div>
</template>
<script>
import mpTitle from "@/components/mp-page/mp-title.vue";
import mpDiver from "@/components/mp-page/mp-diver.vue";
import mpTContext from "@/components/mp-page/mp-title-and-context.vue";
import mpContext from "@/components/mp-page/mp-context.vue";
import mpFooter from "@/components/mp-page/mp-footer.vue";
import privacyData from "./privacy.js";
export default {
  components: {
    mpTitle,
    mpDiver,
    mpTContext,
    mpContext,
    mpFooter
  },
  mounted() {
    this.toPage();
    this.mpPrivacyData = privacyData;
  },
  methods: {
    toPage() {
      this.$store.dispatch("commitIsShow", false);
    }
  },

  data() {
    return {
      mpPrivacyData: []
    };
  }
};
</script>
<style scoped>
.pageView {
  padding: 30px 15vw;
  min-height: 200px;
}
</style>
